export class InterfaceBasketItem {
    item: any;
    type: string;
    quantity: number;
}
export class Basket {
    items: InterfaceBasketItem[];
    total:number=0;
    sub_total:number=0;
    tax:number=0;
    tax_rate:number = 20;
    delivery:number =0;
    delivery_address_id:number;
    billing_address_id:number;
    discount_type:string;
    discount_label:string;
    discount_amount:number;
    discount_value:number;
    discount_stream_id:number;
    discount_stream_global:number;
    currency:string;
    constructor(basket?) {
        this.items = basket.items || [];
        this.tax = basket.tax || 0;
        this.sub_total = basket.sub_total || 0;
        this.delivery_address_id = basket.delivery_address_id || null;
        this.billing_address_id = basket.billing_address_id || null;
        this.discount_type=basket.discount_type || null;
        this.discount_label=basket.discount_label || null;
        this.discount_amount=basket.discount_amount || 0;
        this.discount_value=basket.discount_value || 0;
        this.discount_stream_id=0;
        this.discount_stream_global=0;
        this.currency='GBP'
    }
}
